module.exports = __webpack_public_path__ + "img/28f65d2.jpg";